import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const SkipLink = styled('a')(({ theme }) => ({
  position: 'fixed',
  top: theme.spacing(1),
  left: theme.spacing(1),
  zIndex: theme.zIndex.tooltip + 1,
  padding: theme.spacing(1, 2),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: '#fe6804',
  color: theme.palette.primary.main,
  fontWeight: 600,
  textDecoration: 'none',
  boxShadow: theme.shadows[4],
  transform: 'translateY(-150%)',
  opacity: 0,
  transition: 'transform 0.2s ease-out, opacity 0.2s ease-out',
  '&:focus,&:focus-visible': {
    transform: 'translateY(0)',
    opacity: 1,
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },
}));

interface SkipToMainContentProps {
  targetId?: string;
}

const SkipToMainContent = ({ targetId = 'main-content' }: SkipToMainContentProps) => {
  const { t } = useTranslation('common');

  const handleActivate = () => {
    // Let default anchor behavior run first; then ensure focus lands on the main element.
    setTimeout(() => {
      const main = document.getElementById(targetId);
      if (main) {
        main.focus();
      }
    }, 0);
  };

  return (
    <SkipLink
      href={`#${targetId}`}
      onClick={handleActivate}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          handleActivate();
        }
      }}
    >
      {t('ACCESSIBILITY.SKIP_TO_MAIN_CONTENT')}
    </SkipLink>
  );
};

export default SkipToMainContent;
